<template>
  <section class="entity-hearing-loss-rules">
    <collapsable
      :collapsed="collapsed"
      :title="$t('hearinglossrules.table_header')"
    >
      <HearingLossRulesTable
        ref="hearingLossRulesTable"
        :entity="entity"
        :limit="25"
        :shouldShowLimit="false"
      />

      <CreateOrUpdateHearingLossRule
        v-if="isCreatingRule"
        :entity="entity"
        @rule-created="onRuleCreated"
        @cancel="onCancelCreateRule"
      />

      <div class="d-flex justify-content-end">
        <va-button v-if="hasWriteHearingLossRulesPermissions"
          @click.prevent="createRule">
          {{ $t('hearinglossrules.create_rule') }}
        </va-button>
      </div>

    </collapsable>
  </section>
</template>
<script>
import Collapsable from '@/components/common/Collapsable'
import HearingLossRulesTable from '@/components/entities/hearinglossrules/HearingLossRulesTable'
import CreateOrUpdateHearingLossRule from '@/components/entities/hearinglossrules/CreateOrUpdateHearingLossRule'
export default {
  props: {
    entity: {
      type: Object,
      required: false
    },
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Collapsable,
    HearingLossRulesTable,
    CreateOrUpdateHearingLossRule
  },
  computed: {
    hasWriteHearingLossRulesPermissions: function () {
      return this.$auth.user().entity.id === 1
    }
  },
  data () {
    return {
      isCreatingRule: false,
    }
  },
  methods: {
    createRule: function () {
      this.isCreatingRule = true
    },
    onRuleCreated: function () {
      this.isCreatingRule = true
      this.$refs.hearingLossRulesTable.refresh()
    },
    onCancelCreateRule: function () {
      this.isCreatingRule = false
    }
  }
}
</script>
